import axios from 'axios';
import config from '../config';
import { getBearerToken } from '../util/cookie';
import { updateProfile } from '../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import { saveSessionsBulk } from './sessions.duck';

// ================ Action types ================ //

export const PROGRAMS_REQUEST = 'app/CoachSaaS/PROGRAMS_REQUEST';
export const PROGRAMS_SUCCESS = 'app/CoachSaaS/PROGRAMS_SUCCESS';
export const PROGRAMS_ERROR = 'app/CoachSaaS/PROGRAMS_ERROR';

// export const PROGRAM_GET_REQUEST = 'app/CoachSaaS/PROGRAM_GET_REQUEST';
// export const PROGRAM_GET_SUCCESS = 'app/CoachSaaS/PROGRAM_GET_SUCCESS';
// export const PROGRAM_GET_ERROR = 'app/CoachSaaS/PROGRAM_GET_ERROR';

export const PROGRAM_SAVE_REQUEST = 'app/CoachSaaS/PROGRAM_SAVE_REQUEST';
export const PROGRAM_SAVE_SUCCESS = 'app/CoachSaaS/PROGRAM_SAVE_SUCCESS';
export const PROGRAM_SAVE_ERROR = 'app/CoachSaaS/PROGRAM_SAVE_ERROR';

export const PROGRAM_DELETE_REQUEST = 'app/CoachSaaS/PROGRAM_DELETE_REQUEST';
export const PROGRAM_DELETE_SUCCESS = 'app/CoachSaaS/PROGRAM_DELETE_SUCCESS';
export const PROGRAM_DELETE_ERROR = 'app/CoachSaaS/PROGRAM_DELETE_ERROR';

// ================ Reducer ================ //

const initialState = {
  programs: [],
  programs_error: null,
  programs_fetching: false,

  // program: null,
  // programError: null,
  // programFetching: false,

  programSave: null,
  programSaving: null,
  programSavingError: null,

  programDelete: null,
  programDeleting: false,
  programDeletingError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case PROGRAMS_REQUEST:
      return {
        ...state,
        programs_fetching: true,
      };
    case PROGRAMS_SUCCESS:
      return {
        ...state,
        programs_fetching: false,
        programs: payload,
      };
    case PROGRAMS_ERROR:
      return {
        ...state,
        programs_fetching: false,
        programs_error: payload,
      };

    // case PROGRAM_GET_REQUEST:
    //   return {
    //     ...state,
    //     programFetching: true,
    //   };
    // case PROGRAM_GET_SUCCESS:
    //   return {
    //     ...state,
    //     programFetching: false,
    //     program: payload,
    //   };
    // case PROGRAM_GET_ERROR:
    //   return {
    //     ...state,
    //     programFetching: false,
    //     programError: payload,
    //   };

    case PROGRAM_SAVE_REQUEST:
      return {
        ...state,
        programSaving: true,
      };
    case PROGRAM_SAVE_SUCCESS:
      return {
        ...state,
        programSaving: false,
        programSave: payload,
      };
    case PROGRAM_SAVE_ERROR:
      return {
        ...state,
        programSaving: false,
        programSavingError: payload,
      };

    case PROGRAM_DELETE_REQUEST:
      return {
        ...state,
        programDeleting: true,
      };
    case PROGRAM_DELETE_SUCCESS:
      return {
        ...state,
        programDeleting: false,
        programDelete: payload,
      };
    case PROGRAM_DELETE_ERROR:
      return {
        ...state,
        programDeleting: false,
        programDeletingError: payload,
      };
  
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const programsRequest = () => ({ type: PROGRAMS_REQUEST });
export const programsSuccess = data => ({ type: PROGRAMS_SUCCESS, payload: data });
export const programsError = error => ({ type: PROGRAMS_ERROR, payload: error });

// export const programRequest = () => ({ type: PROGRAM_GET_REQUEST });
// export const programSuccess = data => ({ type: PROGRAM_GET_SUCCESS, payload: data });
// export const programError = error => ({ type: PROGRAM_GET_ERROR, payload: error });

export const programsSaveRequest = () => ({ type: PROGRAM_SAVE_REQUEST });
export const programsSaveSuccess = data => ({ type: PROGRAM_SAVE_SUCCESS, payload: data });
export const programsSaveError = error => ({ type: PROGRAM_SAVE_ERROR, payload: error });

export const programDeleteRequest = () => ({ type: PROGRAM_DELETE_REQUEST });
export const programDeleteSuccess = data => ({ type: PROGRAM_DELETE_SUCCESS, payload: data });
export const programDeleteError = error => ({ type: PROGRAM_DELETE_ERROR, payload: error });

// ================ Thunks ================ //

export const getAllPrograms = (docId, goTo) => async (dispatch, getState, sdk) => {
  dispatch(programsRequest());

  return axios
    .get(`${config.coachSaaSService}programs`, {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
        docId: docId,
        goTo: goTo,
      },
    })
    .then(res => {
      if(res.data.length > 0){
        dispatch(programsSuccess(res.data));
      }
      dispatch(programsSuccess(getState().programs.programs));
    })
    .catch(err => {
      console.log(err);
      dispatch(programsError(err));
    });
};

/**
 * reconcileOnboardingFlags
 *
 * Legacy-coach backfill. The onboarding checklist (StepsInViveka) marks the
 * "Create a program" and "Create a listing" steps complete by reading the
 * privateData flags `isProgramCreated` / `isCreatedAListing`. Those flags are
 * only written going forward — when a coach creates a program
 * (sessions.duck.js) or publishes a listing (EditListingPage.duck.js). Coaches
 * who already had programs/listings in Viveka before the flags existed have
 * them unset, so onboarding wrongly asks them to create new ones.
 *
 * This thunk detects existing data and backfills the flags once:
 *   - isCreatedAListing ← the coach already has a published own-listing
 *   - isProgramCreated  ← the coach already has at least one coach-saas program
 *
 * Idempotent: bails immediately when both flags are already true, only ever
 * sets (never unsets) flags, and writes a single merged updateProfile. Once
 * set, currentUser refetches and subsequent runs early-return, so repeated
 * mounts are cheap.
 */
export const reconcileOnboardingFlags = () => async (dispatch, getState, sdk) => {
  const { currentUser } = getState().user;
  if (!currentUser || !currentUser.attributes) return;

  const profile = currentUser.attributes.profile || {};
  const isProvider = profile.publicData && profile.publicData.isProvider;
  if (!isProvider) return;

  const privateData = profile.privateData || {};
  const alreadyProgram = privateData.isProgramCreated === true;
  const alreadyListing = privateData.isCreatedAListing === true;
  if (alreadyProgram && alreadyListing) return; // nothing to backfill

  const updates = {};

  // Listing step: a published own-listing counts (mirrors the publish-time
  // flag write and user.duck's currentUserHasListings, which excludes drafts).
  if (!alreadyListing) {
    try {
      const res = await sdk.ownListings.query({ page: 1, per_page: 100 });
      const listings = (res && res.data && res.data.data) || [];
      const hasPublishedListing = listings.some(
        l => l.attributes && l.attributes.state && l.attributes.state !== 'draft'
      );
      if (hasPublishedListing) updates.isCreatedAListing = true;
    } catch (e) {
      console.log('reconcileOnboardingFlags: listing check failed', e);
    }
  }

  // Program step: any existing coach-saas program counts.
  if (!alreadyProgram) {
    try {
      const res = await axios.get(`${config.coachSaaSService}programs`, {
        headers: {
          'content-type': 'application/json',
          Authorization: await getBearerToken(sdk),
        },
      });
      const hasProgram = Array.isArray(res.data) && res.data.length > 0;
      if (hasProgram) updates.isProgramCreated = true;
    } catch (e) {
      console.log('reconcileOnboardingFlags: program check failed', e);
    }
  }

  if (Object.keys(updates).length > 0) {
    dispatch(updateProfile({ privateData: updates }));
  }
};

export const getProgram = id => async (dispatch, getState, sdk) => {
  return axios
    .get(`${config.coachSaaSService}programs/${id}`, {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    })
};

export const saveProgram = (data) => async (dispatch, getState, sdk) => {
  dispatch(programsSaveRequest());
  const id = data.id;
  const params = {
    name: data.name,
    description: data.description,
    listings: data.listings,
    // Optional Firebase Storage URL for the program cover image. Coaches upload
    // it via SaaSProgramEditPage; rendered as the hero on SaaSProgramsPage cards.
    image: data.image,
    phases: data.phases,
  }

  let url = '';
  if (id) {
    url = `${config.coachSaaSService}programs/${id}`;
  } else {
    url = `${config.coachSaaSService}programs`;
  }

  return axios
    .post(url, params, {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    })
    .then(res => {
      dispatch(programsSaveSuccess(res.data));
      return res.data;
    })
    .catch(err => {
      console.log(err);
      dispatch(programsSaveError(err));
      // Re-throw the structured cap error so the page can show its
      // upgrade modal. Wave 1 backend returns:
      //   403 { ok: false, error: 'tier-cap-reached', feature, tier,
      //         limit, current }
      // For other failures we keep the legacy behaviour (no throw)
      // so existing call sites aren't surprised.
      const status = err && err.response && err.response.status;
      const body = err && err.response && err.response.data;
      if (status === 403 && body && body.error === 'tier-cap-reached') {
        const capErr = new Error('tier-cap-reached');
        capErr.tierCap = {
          feature: body.feature,
          tier: body.tier,
          limit: body.limit,
          current: body.current,
        };
        throw capErr;
      }
    });
};

// Copies a program (name, description, image, phases) and all of its
// sessions into a brand-new program. There's no backend duplicate-program
// endpoint (only single-session duplicate exists), so this composes the
// existing single-resource endpoints: fetch source program + sessions,
// create the new program via saveProgram (which already surfaces
// tier-cap-reached the same way SaaSProgramEditPage handles it — that
// error propagates out of this thunk uncaught, same contract), then
// recreate each session under the new program via saveSessionsBulk.
// sessionsCount/orderIndex/timestamps are intentionally not copied — the
// backend regenerates those for every session it creates.
export const duplicateProgram = progId => async (dispatch, getState, sdk) => {
  const authHeader = { Authorization: await getBearerToken(sdk) };

  const [programRes, sessionsRes] = await Promise.all([
    axios.get(`${config.coachSaaSService}programs/${progId}`, {
      headers: { 'content-type': 'application/json', ...authHeader },
    }),
    axios.get(`${config.coachSaaSService}programs/${progId}/sessions`, {
      headers: { 'content-type': 'application/json', ...authHeader },
    }),
  ]);

  const source = programRes.data || {};
  const sourceSessions = (sessionsRes.data && sessionsRes.data.sessions) || [];

  const newProgram = await dispatch(
    saveProgram({
      name: `Copy - ${source.name}`,
      description: source.description,
      image: source.image,
      phases: source.phases,
    })
  );

  if (!newProgram || !newProgram.id) {
    return newProgram;
  }

  if (sourceSessions.length > 0) {
    const sessionsData = sourceSessions.map(s => ({
      name: s.name,
      description: s.description,
      coachPreparation: s.coachPreparation,
      coachSessionPlan: s.coachSessionPlan,
      clientPreparation: s.clientPreparation,
      clientPreparationFiles: s.clientPreparationFiles || [],
      duration: s.duration,
    }));
    await dispatch(saveSessionsBulk(newProgram.id, sessionsData));
  }

  return newProgram;
};

export const deleteProgram = id => async (dispatch, getState, sdk) => {
  dispatch(programDeleteRequest());
  return axios
    .delete(`${config.coachSaaSService}programs/${id}`, {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    })
    .then(res => {
      dispatch(programDeleteSuccess(res));
    })
    .catch(err => {
      console.log(err);
      dispatch(programDeleteError(err));
    })
};